import { ThemeOptions } from '@melio/penny';

import { Spinner } from './loader';
import { CloverLogo, CloverLogoDark } from './logos';

export const cloverTheme: ThemeOptions = {
  loader: Spinner,
  logos: {
    light: CloverLogo,
    dark: CloverLogoDark,
  },
  fonts: {
    primary: 'Graphik, Helvetica, Arial, sans-serif',
  },
  colors: {
    brand: {
      darkest: '#1F5B10',
      dark: '#276A16',
      main: '#228800',
      light: '#43B02A',
      lighter: '#F2FCEE',
      lightest: '#F9FFF7',
    },
    critical: {
      darkest: '#AA1111',
      dark: '#C60000',
      main: '#E70000',
      lightest: '#FFEDED',
    },
    success: {
      darkest: '#1F5B10',
      dark: '#276A16',
      main: '#228800',
      lightest: '#F2FCEE',
    },
    warning: {
      main: '#FFD100',
      lightest: '#FFF6CC',
    },
    info: {
      main: '#339DFF',
      lightest: '#E6F3FF',
    },
    neutral: {
      black: '#000000',
      darkest: '#5C5C5C',
      darker: '#8E8E90',
      dark: '#C7C7C7',
      light: '#D8D8D8',
      lighter: '#E5E5E5',
      lightest: '#FBFBFB',
      white: '#FFFFFF',
    },
    link: {
      rest: '#000000',
      hover: '#3271AB',
      pressed: '#285A88',
    },
    components: {
      nakedButton: {
        secondary: {
          default: { color: '#3271AB' },
          hover: { color: '#285A88' },
          active: { color: '#285A88' },
        },
      },
    },
  },
};
